import React from 'react';
import { cn } from '../lib/utils';

/** Big Mummy’s script logo (dark ink, transparent). Best on light surfaces. */
export function BrandLogo({ className = '', alt = 'Big Mummy’s' }) {
  return <img src="/bigmummy-logo.png" alt={alt} className={cn('object-contain', className)} />;
}

/** Square app mark (cream script on espresso). Works on any background. */
export function BrandMark({ className = '' }) {
  return <img src="/bigmummy-icon.png" alt="Big Mummy’s" className={cn('object-contain rounded-lg', className)} />;
}

/**
 * Compact logo for dense headers. Callers pass the text colour they used for the old text
 * wordmark; a white text class means a dark surface, so the cream logo is used there.
 */
export function BrandWordmark({ className = '' }) {
  const onDark = /text-white|text-teal-|text-cream/.test(className);
  const h = /text-(2xl|3xl|4xl)/.test(className) ? 'h-10' : 'h-8';
  return (
    <img
      src={onDark ? '/bigmummy-logo-light.png' : '/bigmummy-logo.png'}
      alt="Big Mummy’s"
      className={cn('object-contain w-auto', h)}
    />
  );
}

export default BrandLogo;
